module.exports = __webpack_public_path__ + "static/media/Rebecca@2x.393727b4.png";